import AuthPass from "../auth/auth-pass";

// Очистка корзины
function clearBasket() {
  $.ajax({
    method: 'POST',
    url: '/ajax/clear-basket.php',
    cache: false,
    contentType: false,
    processData: false,
    dataType: 'json',
    success: function (result) {
      if (result.success) {
        let $modalClearBasket = $(document).find('#clearBasketModal');
        // очищаем корзину
        if ($(document).find('.full_basket').length) {
          $.ajax({
            url: '/personal/cart/',
            success: function (res) {
              $(document).find('.full_basket').html($(res).find('.full_basket').html());
            }
          });
        } else {
          // обновляем малую корзимну
          window.reloadBasket(false, false, true);
          // обновляем кнопки у товаров
          if ($(document).find('.x-product-box').length) {
            $(document).find('.x-product-box').each(function () {
              let $addButton = $(this).find('.x-add-button'),
                $addQuantity = $(this).find('.x-add-quantity'),
                $addValue = $(this).find('.x-add-value');

              $addButton.prop('disabled', false);
              $addValue.text(0);
              $addQuantity.find('.x-add-plus').removeClass('active');
              $addQuantity.fadeOut(250, function () {
                $addButton.fadeIn(150);
              });
            });
          }
          // очищаем календарь
          $(document).find('.js-catalog-menu-day').find('.js-calendar-day-price').html('');
        }

        // закрываем модальное окно
        if ($modalClearBasket.length) {
          $modalClearBasket.foundation('close');
        }
      }
    }
  })
}

(function ($) {
  "use strict";
  $(function () {
    function proceedCheckout() {
      location.reload();
    }

    $('[data-entity="proceed-checkout"]').on('click', function (e) {
      try {
        if (!window.authPass instanceof AuthPass) {
          window.authPass = new AuthPass();
        }
        window.authPass.bindFinalAction(function () {
          proceedCheckout();
        }.bind(this));
        window.authPass.bindFaultAction(function () {
          proceedCheckout();
        }.bind(this));
        $('#sms-confirm-reveal').foundation('open');
      } catch (e) {
        window.location.href = '/personal/order/';
      }
    });
    $(document).on('click', '.x-clear-basket-modal', function (e) {
      e.preventDefault();
      e.stopPropagation();

      let $modalClearBasket = $(document).find('#clearBasketModal');
      if ($modalClearBasket.length) {
        $modalClearBasket.foundation('open');
      }
    });

    $(document).on('click', '.x-clear-basket-clear', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearBasket();
    });
  });
})(jQuery);



